module.exports = __webpack_public_path__ + "static/media/serhatsakarya.52bea90e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/serhatsakarya.webp
// module id = 414
// module chunks = 0